<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-info-card
        title="KEEP IN TOUCH WITH US"
        pace="6"
      >
        주식회사 오라스코프는<br>데이터베이스 컨설팅과 데이터베이스 관련 솔루션 개발을 업으로 하고 있습니다.
      </base-info-card>

      <base-business-contact dense />
    </div>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'BaseBusinessInfo',

    props: { dark: Boolean },

    data: () => ({
      business: [
        {
          icon: 'mdi-map-marker-outline',
          title: 'Address',
          text: '8553 N. Beach St. Ste. 227<br>Fort Worth, Texas 76137',
        },
        {
          icon: 'mdi-cellphone',
          title: 'Phone',
          text: '02) 2686-8400',
        },
        {
          icon: 'mdi-email',
          title: 'Email',
          text: 'sales@orascope.net',
        },
      ],
    }),
  }
</script>
